import { childrenKeys, Structure, DeepStructure, ChildrenKey } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

const { MOBILE_COMPONENTS, MASTER_PAGE_CHILDREN, COMPONENTS } = childrenKeys

export const getChildrenKey = (component: DeepStructure, isMobile: boolean): ChildrenKey => {
	if (isMobile && component.mobileComponents) {
		return MOBILE_COMPONENTS
	}

	return component.children ? MASTER_PAGE_CHILDREN : COMPONENTS
}

const getChildrenComponents = (structure: DeepStructure, isMobile: boolean): Array<DeepStructure> => {
	const childrenKey = getChildrenKey(structure, isMobile)
	return structure[childrenKey] || []
}

const getAllCompsInStructure = (compStructure: DeepStructure, isMobile: boolean): Record<string, DeepStructure> => {
	const queue = [compStructure]
	for (const component of queue) {
		const childrenData = _.map(getChildrenComponents(component, isMobile), (childStructure) => ({
			...childStructure,
			parent: component.id,
		}))

		queue.push(...childrenData)
	}

	return queue.reduce((acc, val) => Object.assign(acc, { [val.id]: val }), {})
}

export const flattenStructure = (pageStructure: DeepStructure, isMobile: boolean, pageCompId?: string): Structure => {
	const pageId = pageCompId ? pageCompId : pageStructure.id
	const metaData = { pageId }
	const convertChildrenToIds = (comp: DeepStructure) => {
		const newComp = {
			..._.omit(comp, [MASTER_PAGE_CHILDREN, MOBILE_COMPONENTS]),
			metaData,
		}
		const compChildren = comp[getChildrenKey(comp, isMobile)]
		return compChildren
			? {
					...newComp,
					components: compChildren.map((item) => item.id),
					metaData: { pageId },
			  }
			: newComp
	}

	const struct = getAllCompsInStructure(pageStructure, isMobile)
	const flatStructure = Object.keys(struct).reduce(
		(acc, id) => Object.assign(acc, { [id]: convertChildrenToIds(struct[id]) }),
		{}
	)
	return _.mapValues(flatStructure, (comp) => _.mapValues(comp, (v) => (_.isString(v) ? v.replace('#', '') : v)))
}
